import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { CheckIcon, XIcon } from "../../../constants/Icons";

const PaymentMethod = ({ open, onClose, totalPayable, onDone, isRounded }) => {
  const [cash, setCash] = useState(0);
  const [upi, setUpi] = useState(0);
  const [card, setCard] = useState(0);
  const [online, setOnline] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [balance, setBalance] = useState(0);
  const [totalPaid, setTotalPaid] = useState(totalPayable);

  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const upiRef = useRef(null);
  const onlineRef = useRef(null);
  const paylaterRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    // Clear when opened
    if (open) {
      setCash(0);
      setUpi(0);
      setCard(0);
      setOnline(0);
      setPaylater(0);
    }
  }, [open]);

  useEffect(() => {
    const cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    const cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    const upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    const onlineAmt = CurrencyConverter.toSubunit(online || 0, "INR");
    const creditAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");

    const paid = cashAmt + cardAmt + upiAmt + onlineAmt + creditAmt;

    setTotalPaid(CurrencyConverter.toCurrency(paid, "INR"));
    setBalance(Number(totalPayable) - paid);
  }, [cash, card, upi, online, paylater, totalPayable]);

  const handleInputChange = (setValue, mode) => (e) => {
    const value = e.target.value;

    if (value === "") {
      setValue("");
      return;
    }

    if (!/^\d*\.?\d{0,2}$/.test(value)) return;

    const enteredSub = CurrencyConverter.toSubunit(Number(value), "INR");

    const amounts = {
      cash: CurrencyConverter.toSubunit(Number(cash || 0), "INR"),
      card: CurrencyConverter.toSubunit(Number(card || 0), "INR"),
      upi: CurrencyConverter.toSubunit(Number(upi || 0), "INR"),
      online: CurrencyConverter.toSubunit(Number(online || 0), "INR"),
      credit: CurrencyConverter.toSubunit(Number(paylater || 0), "INR"),
    };

    // Remove current field amount
    if (mode === "cash") amounts.cash = 0;
    if (mode === "card") amounts.card = 0;
    if (mode === "upi") amounts.upi = 0;
    if (mode === "online") amounts.online = 0;
    if (mode === "credit") amounts.credit = 0;

    const paidWithoutCurrent =
      amounts.cash +
      amounts.card +
      amounts.upi +
      amounts.online +
      amounts.credit;

    const remainingSub = Math.max(0, Number(totalPayable) - paidWithoutCurrent);

    const finalSub = Math.min(enteredSub, remainingSub);

    setValue(Number(CurrencyConverter.toCurrency(finalSub, "INR")));
  };

  const handleFocusFill = (mode) => {
    const payableSub = Number(totalPayable || 0);

    const currentCash = CurrencyConverter.toSubunit(cash || 0, "INR");
    const currentCard = CurrencyConverter.toSubunit(card || 0, "INR");
    const currentUpi = CurrencyConverter.toSubunit(upi || 0, "INR");
    const currentonline = CurrencyConverter.toSubunit(online || 0, "INR");
    const currentPaylater = CurrencyConverter.toSubunit(paylater || 0, "INR");

    const totalAlreadyPaid =
      currentCash + currentCard + currentUpi + currentonline + currentPaylater;

    const remainingSub = payableSub - totalAlreadyPaid;

    if (remainingSub <= 0) return;

    const remaining = Number(CurrencyConverter.toCurrency(remainingSub, "INR"));

    if (mode === "cash") {
      setCash((prev) => Number(prev || 0) + remaining);
      setTimeout(() => cashRef.current?.select(), 0);
    }

    if (mode === "card") {
      setCard((prev) => Number(prev || 0) + remaining);
      setTimeout(() => cardRef.current?.select(), 0);
    }

    if (mode === "upi") {
      setUpi((prev) => Number(prev || 0) + remaining);
      setTimeout(() => upiRef.current?.select(), 0);
    }

    if (mode === "online") {
      setOnline((prev) => Number(prev || 0) + remaining);
      setTimeout(() => onlineRef?.current?.select(), 0);
    }

    if (mode === "credit") {
      setPaylater((prev) => Number(prev || 0) + remaining);
    }
  };
  // const handlePaymodeKeyDown = (e, mode, currentValue) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     const numericValue = Number(currentValue || 0);
  //     if (!numericValue) {
  //       handleFocusFill(mode);
  //     }
  //     handleAdd(e);
  //   }
  // };

  const handleEnterKey = (e, nextRef = null) => {
    if (e.key === "Enter") {
      e.preventDefault();

      if (nextRef?.current) {
        setTimeout(() => {
          nextRef.current.focus();
          nextRef.current.select();
        }, 0);
      }
    }
  };

  if (!open) return null;

  return (
    <div>
      <div className="modal-backdrop show"> </div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div
          className="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
          // onClick={stopEventPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Payment Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {/* Total Section */}
            <div className="modal-body bg-light">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="rounded">
                      <div className="bg-light rounded p-2 text-center mb-3">
                        <h6 className="mb-0 fs-18 text-dark">
                          Total Refund Amount :{" "}
                          <span>
                            {" "}
                            ₹
                            {CurrencyConverter.toCurrency(
                              Math.abs(totalPayable),
                              "INR",
                            )}{" "}
                          </span>
                        </h6>
                      </div>
                      <div className="flex-grow-1 row justify-content-between align-items-center g-2">
                        <div className="col-6">
                          <h6 className="mb-0">Cash</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className="form-control"
                            min="0"
                            name="cash"
                            autoComplete="off"
                            value={cash}
                            ref={cashRef}
                            onClick={() => handleFocusFill("cash")}
                            onKeyDown={(e) => handleEnterKey(e, cardRef)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setCash, "cash")}
                          />
                        </div>
                        <div className="col-6">
                          <h6 className="mb-0">Card</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="card"
                            ref={cardRef}
                            autoComplete="off"
                            className="form-control"
                            min="0"
                            value={card}
                            onClick={() => handleFocusFill("card")}
                            onKeyDown={(e) => handleEnterKey(e, onlineRef)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setCard, "card")}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">Online Pay</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="online"
                            ref={onlineRef}
                            autoComplete="off"
                            className="form-control"
                            min="0"
                            value={online}
                            onClick={() => handleFocusFill("online")}
                            onKeyDown={(e) => handleEnterKey(e, upiRef)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setOnline, "online")}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">UPI</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            name="upi"
                            ref={upiRef}
                            className="form-control"
                            autoComplete="off"
                            min="0"
                            value={upi}
                            onClick={() => handleFocusFill("upi")}
                            onKeyDown={(e) => handleEnterKey(e, paylaterRef)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setUpi, "upi")}
                          />
                        </div>

                        <div className="col-6">
                          <h6
                            className={`mb-0 
                                                      ${
                                                        balance === 0
                                                          ? "text-grey"
                                                          : balance > 0
                                                            ? "text-danger"
                                                            : "text-success"
                                                      }`}
                          >
                            {balance === 0
                              ? "Balance"
                              : balance > 0
                                ? "Balance"
                                : "Change"}
                          </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className={`form-control ${
                              balance === 0
                                ? "bg-box-grey"
                                : balance > 0
                                  ? "bg-box-danger"
                                  : "bg-box-success"
                            }`}
                            value={CurrencyConverter.toCurrency(balance, "INR")}
                            //  value={Math.max(0, totalPayable-(cash+card+upi))}
                            disabled
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0 bg-dark-text fw-500">
                            Total Refund
                          </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className="form-control text-dark"
                            value={totalPaid || 0}
                            disabled
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0 text-brown">Paylater</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={paylaterRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={paylater}
                            onClick={() => handleFocusFill("credit")}
                            onKeyDown={(e) => handleEnterKey(e, null)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setPaylater)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="modal-footer d-block">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary text-right"
                ref={btnRef}
                disabled={
                  CurrencyConverter.toSubunit(totalPaid || 0, "INR") <
                  Number(totalPayable || 0)
                }
                onClick={() =>
                  onDone({
                    cash,
                    upi,
                    card,
                    online,
                    paylater,
                    totalPaid,
                  })
                }
              >
                <CheckIcon/> Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
